var tag, env = 'test', 
  topic = 'expressFrontEndLog', 
  fioUrl = 'common-sit1.fcbox.com/cdn/staticResource/commonUtil/fio/fio.js',
  projectName = "fc_express";

if (location.host == 'edms.fcbox.com') {  //注 此次修改成各项目自己的业务域名
  fioUrl = 'common.fcbox.com/cdn/staticResource/commonUtil/fio/fio.js'
  env = 'online'
}

!(function (e, t, n, g, i) { e[i] = e[i] || function () { (e[i].q = e[i].q || []).push(arguments) }, n = t.createElement('script'), tag = t.getElementsByTagName('script')[0], n.async = 1, n.src = (document.location.protocol == 'https:' ? 'https://' : 'http://') + g, tag.parentNode.insertBefore(n, tag) }(window, document, 'script', fioUrl, 'fio'))

window.fio('init', {
  fc_project: projectName,
  env,
  topic
})